export default {
  init() {
    $('#filter').change(function() {
      var filter = $('#filter');
      if (filter.serialize() === 'filterChecks=all&action=myfiltermembers') {
        $('#datafetch').html('');
        $('.team-members').show();
      } else {
        $.ajax({
          url:filter.attr('action'),
          data:filter.serialize(), // form data
          type:filter.attr('method'), // POST
          beforeSend:function(xhr) {
            document.querySelector('.spinner').style.display = 'block';
          },
          success:function(data) {
            document.querySelector('.spinner').style.display = 'none';
            $('.team-members').hide();
            $('#datafetch').html(data);
          },
        });
        return false;
      }
    });

    $('.input#keyword').on('input', function() {
      if ($(this).val().length) {
        $("#datafetch").show();
      } else {
        $("#datafetch").hide();
      }
    });

    $(window).keydown(function(event){
      if(event.keyCode == 13) {
        event.preventDefault();
        return false;
      }
    });
  },
  finalize() {
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/templateMembers.js